import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { isTranslated } from '@/models/translation.model';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TranslatedState',
  props: {
  item: {
    type: Object,
    required: true,
    default: () => ({}),
  },
},
  setup(__props) {

// eslint-disable-next-line
const props = __props;

const tooltip = computed<string>(
  () =>
    isTranslated(props.item)
      ? 'Item is all translated'
      : `Item is missing one or more translations`, //${notTranslatedKeys(props.item).join(',')}
);
const icon = computed<string>(() =>
  isTranslated(props.item) ? 'mdi-progress-check' : 'mdi-progress-close',
);
const color = computed<string>(() =>
  isTranslated(props.item) ? 'green' : 'red',
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, { text: tooltip.value }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_icon, _mergeProps(props, {
        icon: icon.value,
        color: color.value
      }), null, 16, ["icon", "color"])
    ]),
    _: 1
  }, 8, ["text"]))
}
}

})